<div class="dialog">
  <mat-icon class="dialog__close" aria-hidden="false" aria-label="Close icon" mat-dialog-close>close</mat-icon>
  <div mat-dialog-title>
    <h3 l10nTranslate>
      {{ data.title }}
    </h3>
  </div>
  <div mat-dialog-content class="preview-container">
    <div class="image-content">
      <div class="selected-image">
        <ng-container [ngSwitch]="selectedImage?.mediaType">
          <div
            *ngSwitchCase="MediaType.Image"
            miq-bg-image
            class="selected-image-border"
            [imageSrc]="selectedImage?.imageSrc"
            [publishable]="true"
            [disableBGCoverImage]="data?.disableBGCoverImage"
            bgClass="image-preview-thumb"
          ></div>
          <ng-container *ngSwitchCase="MediaType.Video">
            <video
              class="video"
              controls
              [src]="selectedImage?.imageSrc | secureVideoUrlPipe | async"
              type="video/mp4"
            ></video>
          </ng-container>
        </ng-container>
      </div>
      <div class="thumnail-images">
        <div *ngFor="let media of thumbnailInfo; let i = index">
          <ng-container [ngSwitch]="media?.mediaType">
            <div
              *ngSwitchCase="MediaType.Image"
              miq-bg-image
              class="image-border"
              [imageSrc]="media.imageSrc"
              [publishable]="media.publishable"
              bgClass="image-preview-thumb"
              (click)="getSelectedImage(media?.id)"
            >
              <span class="color-hover" [ngClass]="{ colorselected: media?.id === selectedImage?.id }"></span>
            </div>
            <div *ngSwitchCase="'video'" class="image-border" (click)="getSelectedImage(media?.id)">
              <span class="color-hover-video" [ngClass]="{ colorselected: media.id === selectedImage?.id }"></span>
              <mat-icon svgIcon="icon-video" class="file-icon"></mat-icon>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
  <div class="preview-footer">
    <div class="preview-footer-caption">
      <div class="image-caption">{{ selectedImage?.mediaName }}</div>
      <div class="preview-caption">{{ selectedImage?.mediaCaption }}</div>
    </div>
    <div class="preview-footer-icons">
      <mat-icon
        class="preview-icons"
        svgIcon="arrow_up"
        [ngClass]="{ disableIcon: selectedImage?.count === 1 }"
        (click)="changeImage(selectedImage?.count - 2)"
      ></mat-icon>
      <span class="imageCount"> {{ selectedImage?.count + '/' + thumbnailInfo.length }}</span>
      <mat-icon
        class="preview-icons"
        svgIcon="arrow_down"
        [ngClass]="{ disableIcon: selectedImage?.count === thumbnailInfo.length }"
        (click)="changeImage(selectedImage?.count)"
      ></mat-icon>
    </div>
  </div>
</div>
